/** A fight: the zheng in tremolo and sweeping glissandi over a driving low ostinato and drums. */
import { arp, drone } from '../compose';
import { registerTrack } from '../registry';

const A_ZHENG = `@f 6%- 1'_ 2'_ 3' | 2'_ 1'_ 6_ 5_ 6/- | 3'%- 5'_ 3'_ 2' | 1'_ 2'_ 6_ 5_ 6 3'g |
  6'%- 5'_ 3'_ 2' | 3'_ 2'_ 1'_ 2'_ 3'^- | 6_ 1'_ 6_ 5_ 3_ 5_ 6_ 1'_ | 6%-- 0`;
const ROOTS_A = `6,, 6,, 6,, 6,, 3,, 3,, 5,, 6,,`;
const DRIVE = [0, 0, 3, 0, 5, 0, 3, 2];

const B_ZHENG = `@f 6,! 6,_ 1_ 2! 3 | 5_ 3_ 2_ 1_ 6,\\- | 3! 3_ 5_ 6! 1' | 6%--- |
  1'! 6_ 5_ 3! 5 | 6_ 5_ 3_ 2_ 3/- | 5_ 6_ 1'_ 2'_ 3'_ 2'_ 1'_ 2'_ | 6'g-- 0`;
const ROOTS_B = `6,, 6,, 3,, 6,, 5,, 5,, 3,, 6,,`;

const BEAT = `D_ 0_ d_ D_ 0_ D_ d_ d_`;
const FILL = `D_ d_ d_ D_ d_ d_ D_ D_`;
const DRUMS_A = [`D&c_ 0_ d_ D_ 0_ D_ d_ d_`, BEAT, BEAT, FILL, `D&c_ 0_ d_ D_ 0_ D_ d_ d_`, BEAT, BEAT, FILL].join(' | ');
const DRUMS_B = Array(8).fill(`D_ D_ d_ 0_ D_ 0_ d_ t_`).join(' | ');

registerTrack({
  id: 'battle',
  order: 16,
  title: 'ประกายดาบ',
  mood: 'ตื่นเต้น เร่งเร้า ปะทะ',
  use: 'ระหว่างการต่อสู้นอกเมือง',
  key: 'D',
  mode: 'yu',
  bpm: 138,
  meter: 4,
  seed: 1616,
  humanize: 0.25,
  parts: {
    zheng: { inst: 'zheng', pan: 0.12, reverb: 0.25 },
    bass: { inst: 'zheng', gain: 0.55, pan: -0.2, reverb: 0.15 },
    pad: { inst: 'pad', gain: 0.7, reverb: 0.3 },
    drums: { inst: 'perc', gain: 0.5, reverb: 0.2 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { zheng: A_ZHENG, bass: arp(ROOTS_A, DRIVE), pad: drone(ROOTS_A, 4), drums: DRUMS_A },
    },
    B: {
      bars: 8,
      parts: { zheng: B_ZHENG, bass: arp(ROOTS_B, DRIVE), pad: drone(ROOTS_B, 4), drums: DRUMS_B },
    },
    C: {
      bars: 4,
      parts: {
        zheng: `@mf 3%--- | 5%--- | @f 6%--- | 1'%- 6'g-`,
        bass: arp(`6,, 6,, 6,, 6,,`, [0, 0, 0, 0, 0, 0, 0, 0]),
        drums: `D--- | D_ 0_ D_ 0_ D D | D_ D_ d_ d_ D_ D_ d_ d_ | d_ d_ d_ d_ D&c! 0`,
      },
    },
  },
  form: ['A', 'B', 'A', 'C', 'B', 'A', 'C'],
  loop: true,
});
